export const SET_TOKEN = 'SET_TOKEN';
